export default "__VITE_ASSET__H5gcD03v__"